import React from "react";
import PropTypes from "prop-types";

import "./OkCSSLoader.scss";

// New loader with same API as old, but using just CSS.
const OkCSSLoader = ({ className, show, color: backgroundColor, size }) => {
	if (!show) return null;

	const parentStyle = {
		width: size,
		height: size
	};

	const childStyle = {
		backgroundColor,
	};

	return (
		<div className={`ok-css-loader ${className}`} style={parentStyle}>
			{ /* eslint-disable react/no-array-index-key */ }
			{ [ ...Array(12) ].map((_, index) => (
				<div key={index} className={`ok-css-loader-child ok-css-loader-${index + 1}`} >
					<div className="circle" style={childStyle} />
				</div>
			)) }
			{ /* eslint-enable react/no-array-index-key */ }
		</div>
	);
};
OkCSSLoader.Size = {
	xtiny: 10,
	tiny: 16,
	xsmall: 24,
	small: 32,
	medium: 40,
	large: 48,
};

OkCSSLoader.propTypes = {
	className: PropTypes.string,
	show: PropTypes.bool,
	color: PropTypes.string,
	size: PropTypes.number,
};
OkCSSLoader.defaultProps = {
	className: "",
	show: false,
	color: "#3260c7",
	size: OkCSSLoader.Size.medium,
};

export default OkCSSLoader;



// WEBPACK FOOTER //
// ./src/shared/components/OkCSSLoader.jsx